import React, { useCallback } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { BasePopup, Button, Icon, Label } from '@atlas/ui';

import { urlSeparator } from 'common/constants';

const SuccessPopup = ({ data = {}, id }) => {
  const { push } = useHistory();
  const { url } = useRouteMatch();
  const backUrlArray = url.split(urlSeparator);
  backUrlArray.pop();

  const { text, title } = data;

  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  const handleOk = () => {
    handleClose();
    push(backUrlArray.join(urlSeparator));
  };

  return (
    <BasePopup className="success-modal">
      <div className="popup__content">
        <Icon className="success-modal__icon" name="success" />
        <Label className="popup__title" message={title} />
        <Label className="popup__text" message={text} />
      </div>

      <div className="popup__footer">
        <Button className="primary big block" label="ok" onClick={handleOk} />
      </div>
    </BasePopup>
  );
};

SuccessPopup.propTypes = {
  data: PropTypes.object,
  id: PropTypes.string.isRequired,
};

export default SuccessPopup;
